import _default from './Rating';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/modules/Rating/index.js
// module id = 692
// module chunks = 0